import classNames from 'classnames'
import { Link } from 'react-router-dom'

type SegmentedControlLinkProps = {
  options: { value: string; label: string; icon: string; link: string }[]
  value: string
}

export function SegmentedControlLink({ options, value }: SegmentedControlLinkProps) {
  const classNameBase = 'btn d-flex align-items-center'
  const classNameActive = 'btn-secondary text-white label-m-bold'
  const classNameInactive = 'label-m bg-white'

  return (
    <div className="switch-interventi d-flex align-items-center">
      {options.map((option) => (
        <Link
          key={option.value}
          to={option.link}
          className={classNames(classNameBase, {
            [classNameActive]: value === option.value,
            [classNameInactive]: value !== option.value,
          })}
        >
          <span
            className="material-icons me-2"
            style={{
              fontSize: '16px',
            }}
          >
            {option.icon}
          </span>
          {option.label}
        </Link>
      ))}
    </div>
  )
}
